import React from 'react';
import Header from './containers/Header/Header'
const App = () => {
  return (
    <div className='App'>
      <Header />
    </div>
  )
}
export default App